// extracted by mini-css-extract-plugin
export default {"left":"aXROis","external":"bXROis","center":"cXROis","right":"dXROis"};